import { render, staticRenderFns } from "./BrandsView.vue?vue&type=template&id=8d2e501e&scoped=true&"
import script from "./BrandsView.vue?vue&type=script&lang=js&"
export * from "./BrandsView.vue?vue&type=script&lang=js&"
import style0 from "./BrandsView.vue?vue&type=style&index=0&id=8d2e501e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d2e501e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
